import Vue from 'vue'
import App from './App.vue'
import store from './store'
import router from './router'
import { Pagination, Message, Dialog } from 'element-ui'
import './assets/style.scss'

Vue.config.productionTip = false

Vue.use(Dialog)
Vue.use(Pagination)
Vue.prototype.$message = Message

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
